import { Link } from 'gatsby';
import { OutboundLink } from 'gatsby-plugin-gtag';
import { EuiSpacer } from '@elastic/eui';
import CompanyCards from 'components/Indoor_Cameras/IN-6012_HD/Warranty/CompanyCards';
import WeeSymbol from 'components/Indoor_Cameras/IN-6012_HD/Warranty/faq01Image';
import NavButtons from 'components/Indoor_Cameras/IN-6012_HD/NavButtons';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
import * as React from 'react';
export default {
  Link,
  OutboundLink,
  EuiSpacer,
  CompanyCards,
  WeeSymbol,
  NavButtons,
  BreadCrumbs,
  SEOHelmet,
  React
};